import React, { useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import NotFound from '../routes/NotFound'

const ErrorContext = React.createContext({ error: false, setError: () => {} })

export default function ErrorContextProvider(props) {
    const [error, setError] = useState()
    const location = useLocation()

    useEffect(() => {
        const beforeunload_listener = document.addEventListener('beforeunload', () => setError())

        return () => {
            document.removeEventListener('beforeunload', beforeunload_listener)
        }
    })

    useEffect(() => {
        setError()
    }, [location])

    return (
        <ErrorContext.Provider
            value={{
                error,
                setError,
            }}
        >
            {error ? <NotFound /> : props.children}
        </ErrorContext.Provider>
    )
}

export const useError = () => useContext(ErrorContext)
